<template>
  <div>
  <div class="flex flex-wrap items-center flex-col-reverse md:flex-col">
    
    <div class="w-full md:w-1/2 mb-3">
      <draggable :list="itemsarray" animation="100" group="buildreport" tag="ul" class="flex flex-row">
        <li v-for="(choice, index) in itemsarray" class="listbox flex mb-1 w-1/4 overflow-hidden" :key="index">
            <div class="flex items-center inline-block w-6 justify-center bg-gray-200 flex-none cursor-move">{{ index + 1 }}</div>
            <span class="flex-grow align-middle py-2 cursor-move">
              <span class="align-middle text-base">{{ choice.attributes['title'].text }}</span>
            </span>
        </li>
      </draggable>
    </div>
    
    <div class="hrank-wrapper py-3">
      <table>
              <thead class="handle hrank-item mb-1 bg-white mr-2 relative">
                <template v-for="(choice, index) in itemsarray" class="handle hrank-item mb-1 bg-white mr-2 relative">
                  <tr v-for="(attributes, index) in choice.attributes" key="index">
                      <td>{{ index }}</td>
                  </tr>
                </template>
              </thead>
            <tbody>
              <draggable :list="itemsarray" animation="100" group="buildreport" tag="tr" class="hrank-responsive" handle=".handle">
                <template v-for="(choice, index) in itemsarray" class="handle hrank-item mb-1 bg-white mr-2 relative">
                  <template v-for="(attributes, index) in choice.attributes">
                      <td>{{ attributes.text }}</td>
                  </template>
                </template>
              </draggable>
            </tbody>
      </table>
    </div>
  </div>
  <div class="submit-button-wrapper">
        <button id="submitResults" @click="putResults" type="submit" class="px-5 py-2">Next <i aria-hidden="true" class="material-icons align-middle text-5xl">forward</i></button>
    </div>
</div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'
import draggable from 'vuedraggable'

  export default {
    display: "Simple",
    order: 1,
      components: {
        draggable,
      },
        props: {
            array: '',
            route:'',
        },
        data() {
          return {
            itemsarray: this.array,
          }
        },
        methods: {
            putResults: function (event) {
              $( "#submitResults").addClass( "loading" );
              axios.put(this.route, { 
                results: this.array.map(dataSet => dataSet.id) 
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            }
              
          }
      
      };
</script>
